module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"SEND_OTP_TO_ANOTHER_NUMBER":"Ønsker du å få koden til ett annet nummer? "},"en":{"SEND_OTP_TO_ANOTHER_NUMBER":"Receive one time code to different number? "}}')
  delete Component.options._Ctor
}
